module.exports = __webpack_public_path__ + "static/media/cohizon.fe1cb118.svg";